import React from 'react'
import { typeCustomerList } from '../../../api/helpline/qa';
import BasicForm from './form/BasicForm'
import DetailsForm from './form/DetailsForm'
import InvoiceForm from './form/InvoiceForm'
import { typeCisDepartmentList, typeCisUserList, typeContractList } from '../../../api/helpline/keiyaku';
import { typeCategory, typeMemberList } from '../../../api/helpline/master';
import { typeForm, typeDetailsForm } from '../../../pages/ContractRegist'

interface Prop {
  activeStep: number,
  customerList: typeCustomerList[] | undefined,
  handleChangeCompanyCd: (companyObj: any) => void,
  reqbasicItem: {
    custmNo: boolean; custmDepNo: boolean; keiyakuNo: boolean; orderNo: boolean; keiyakuClsCd: boolean; keiyakuStartTs: boolean; renewalMonth: boolean; keiyakuPersonCd: boolean; keiyakuDeposit: boolean; totalPrice: boolean; machineSettingZipCd: boolean; machineSettingAddress: boolean;
  },
  handleChangeForm: (event: React.ChangeEvent<{ value: unknown; name?: string | undefined; }>) => void,
  form: typeForm,
  _onValueChanged: (sender: { value: Date; }) => void
  _onInitialized: (sender: any) => void,
  keiyakuStartTs: Date | null,
  contractList: typeContractList[] | undefined,
  handleChangeKeiyakuCd: (keiyakuObj: typeContractList) => void,
  chipDelete: (i: number, name: string) => void,
  monthList: number[],
  memberList: typeMemberList[] | undefined,
  handleChangeUserCd: (memberObj: typeMemberList) => void,
  payment: typeCategory[],
  cisUserList: typeCisUserList[],
  handleChangeSalesPersonCd: (salesPersonCdObj: typeCisUserList | null) => void,
  handleChangeChecked: (event: React.ChangeEvent<HTMLInputElement>) => void,
  selectmember: typeMemberList | undefined,
  checkbasicItem: { keiyakuNo: boolean; orderNo: boolean; keiyakuDeposit: boolean; totalPrice: boolean; incidentDeposit: boolean; visitCount: boolean; incidentCount: boolean; machineSettingZipCd: boolean; }
  selectKeiyaku: typeContractList | undefined,
  detailsform: typeDetailsForm[],
  displayIncident: boolean,
  checkinvoiceItem: { monthlyPrice: boolean; monthlyPrice2: boolean; demandZipCd: boolean; },
  reqinvoiceItem: {
    demandZipCd: boolean; demandAddress: boolean; demandCompanyName: boolean; demandPersonName: boolean; demandMonth: boolean; actionSeDeptCd: boolean;
  },
  monthSelect: { value: string, name: string }[],
  handleChangeDemandMonth: (event: React.ChangeEvent<HTMLInputElement>) => void,
  demandSelect: string,
  handleChangeDepartmentCd: (departmentObj: typeCisDepartmentList) => void,
  cisDepartmentList: typeCisDepartmentList[],
}

const ContractRegistForm: React.FC<Prop> = (props) => {

  const { activeStep, customerList, handleChangeCompanyCd, reqbasicItem, handleChangeForm, form, _onInitialized, _onValueChanged, keiyakuStartTs, contractList, handleChangeKeiyakuCd, chipDelete, monthList, memberList, handleChangeUserCd, payment, cisUserList, handleChangeSalesPersonCd, handleChangeChecked, selectmember, checkbasicItem, displayIncident, detailsform, reqinvoiceItem, checkinvoiceItem, monthSelect, handleChangeDemandMonth, demandSelect, handleChangeDepartmentCd, cisDepartmentList } = props

  return (
    <React.Fragment>
      <div style={{ padding: '8px' }}>
        {activeStep === 0 &&
          <BasicForm customerList={customerList} handleChangeCompanyCd={handleChangeCompanyCd} reqbasicItem={reqbasicItem} handleChangeForm={handleChangeForm} form={form} _onValueChanged={_onValueChanged} _onInitialized={_onInitialized} keiyakuStartTs={keiyakuStartTs} contractList={contractList} handleChangeKeiyakuCd={handleChangeKeiyakuCd} monthList={monthList} chipDelete={chipDelete} memberList={memberList} handleChangeUserCd={handleChangeUserCd} payment={payment} cisUserList={cisUserList} handleChangeSalesPersonCd={handleChangeSalesPersonCd} handleChangeChecked={handleChangeChecked} selectmember={selectmember} checkbasicItem={checkbasicItem} displayIncident={displayIncident} />}
        {activeStep === 1 &&
          <DetailsForm detailsform={detailsform} />}
        {(activeStep === 2 || activeStep === 3) &&
          <InvoiceForm reqinvoiceItem={reqinvoiceItem} handleChangeForm={handleChangeForm} form={form} chipDelete={chipDelete} monthList={monthList} checkinvoiceItem={checkinvoiceItem} monthSelect={monthSelect} handleChangeDemandMonth={handleChangeDemandMonth} demandSelect={demandSelect} handleChangeDepartmentCd={handleChangeDepartmentCd} cisDepartmentList={cisDepartmentList} />}
      </div>
    </React.Fragment>
  )
}

export default ContractRegistForm
